import { createWorker, PSM } from 'tesseract.js';

export async function recognizeDemandImage(file, onProgress, signal) {
  const base = new URL(`${process.env.PUBLIC_URL || ''}/ocr/`, window.location.origin).href.replace(/\/$/, '');
  let worker;
  let rejectCancellation;
  const cancelled = new Promise((resolve, reject) => { rejectCancellation = reject; });
  const stop = () => {
    rejectCancellation(new Error('辨識已取消'));
    if (worker) { const current = worker; worker = null; current.terminate().catch(() => {}); }
  };
  signal?.addEventListener('abort', stop, { once: true });
  try {
    if (signal?.aborted) throw new Error('辨識已取消');
    const initialize = createWorker(['chi_tra', 'eng'], 1, {
      workerPath: `${base}/worker.min.js`, corePath: base, langPath: base, workerBlobURL: false,
      logger: (message) => { if (!signal?.aborted) onProgress({ status: message.status, progress: Math.round((message.progress || 0) * 100) }); },
    }).then((created) => {
      if (signal?.aborted) { created.terminate().catch(() => {}); throw new Error('辨識已取消'); }
      worker = created; return created;
    });
    await Promise.race([initialize, cancelled]);
    await Promise.race([worker.setParameters({ tessedit_pageseg_mode: PSM.AUTO, preserve_interword_spaces: '1' }), cancelled]);
    const { data } = await Promise.race([worker.recognize(file, {}, { text: true, tsv: true }), cancelled]);
    if (!data.text?.trim()) throw new Error('圖片中未辨識出文字，請確認方向、清晰度及拍攝範圍。');
    return data;
  } finally {
    signal?.removeEventListener('abort', stop);
    if (worker) await worker.terminate();
  }
}
